import { useEffect } from "react"
import TitleCell from "../titleCell"

export const titleCell = (params:any) => { 
    return <TitleCell value={params.value} />
}

export const StatusStaticCell = (params:any) => { 
    return (
        <>
            {params.value? (
                <div className='text-ellipsis overflow-hidden flex items-center gap-2' title={`${params.value}`} style={{ height: `100%` }}>
                    <span style={{ 
                        width: `12px`, 
                        height: `12px`, 
                        borderRadius: `12px`, 
                        display: `flex`, 
                        alignItems: `center`, 
                        justifyContent: `center`,
                        backgroundColor: params.data?.woStatusHexCode || params.data?.statusHexCode || `#333333`,
                    }}></span>
                    <span className={`flex items-center justify-center`} style={{ 
                        /*border: `1px solid #D2D2D2`,*/
                        height: `24px`, 
                        borderRadius: `10px`,
                        padding: `3px 8px`,
                        lineHeight: `normal`,
                        fontSize: `14px`,
                        color: `#000000`
                    }}>{ params.value }</span>            
                </div>
            ): `--`}            
        </>
    )
}

export const StatusStaticAssetCell = (params:any) => { 
    return (
        <>
            {params.value? (
                <div className='text-ellipsis overflow-hidden flex items-center gap-2' title={`${params.value}`} style={{ height: `100%` }}>
                    <span style={{ 
                        width: `12px`, 
                        height: `12px`, 
                        borderRadius: `12px`, 
                        display: `flex`, 
                        alignItems: `center`, 
                        justifyContent: `center`,
                        backgroundColor: params.data?.colourCode || `#333333`,
                    }}></span>
                    <span className={`flex items-center justify-center`} style={{ 
                        /*border: `1px solid #D2D2D2`,*/
                        height: `24px`, 
                        borderRadius: `10px`,
                        padding: `3px 8px`,
                        lineHeight: `normal`,
                        fontSize: `14px`,
                        color: `#000000`
                    }}>{ params.value }</span>            
                </div>
            ): `--`}            
        </>
    )
}

export const StatusStaticWRCell = (params:any) => {    
    return (
        <>
            {params.value? (
                <div className='text-ellipsis overflow-hidden flex items-center gap-2' title={`${params.value}`} style={{ height: `100%` }}>
                    <span style={{ 
                        width: `12px`, 
                        height: `12px`, 
                        borderRadius: `12px`, 
                        display: `flex`, 
                        alignItems: `center`, 
                        justifyContent: `center`,
                        backgroundColor: params.data.workRequestStatusHexCode || `#333333`,
                    }}></span>
                    <span className={`flex items-center justify-center`} style={{ 
                        /*border: `1px solid #D2D2D2`,*/
                        height: `24px`, 
                        borderRadius: `10px`,
                        padding: `3px 8px`,
                        lineHeight: `normal`,
                        fontSize: `14px`,
                        color: `#000000`
                    }}>{ params.value }</span>            
                </div>
            ): `--`}            
        </>
    )
}

export const StatusStaticPRCell = (params:any) => { 
    return (
        <>
            {params.value? (
                <div className='text-ellipsis overflow-hidden flex items-center gap-2' title={`${params.value}`} style={{ height: `100%` }}>
                    <span style={{ 
                        width: `12px`, 
                        height: `12px`, 
                        borderRadius: `12px`, 
                        display: `flex`, 
                        alignItems: `center`, 
                        justifyContent: `center`,
                        backgroundColor: params.data?.purchaseRequestStatusColor || `#333333`,
                    }}></span>
                    <span className={`flex items-center justify-center`} style={{ 
                        height: `24px`, 
                        borderRadius: `10px`,
                        padding: `3px 8px`,
                        lineHeight: `normal`,
                        fontSize: `14px`,
                        color: `#000000`
                    }}>{ params.value }</span>            
                </div>
            ): `--`}            
        </>
    )
}
export const StatusStaticPOCell = (params:any) => { 
    return (
        <>
            {params.value? (
                <div className='text-ellipsis overflow-hidden flex items-center gap-2' title={`${params.value}`} style={{ height: `100%` }}>
                    <span style={{ 
                        width: `12px`, 
                        height: `12px`, 
                        borderRadius: `12px`, 
                        display: `flex`, 
                        alignItems: `center`, 
                        justifyContent: `center`,
                        backgroundColor: params.data?.statusColor || `#333333`,
                    }}></span>
                    <span className={`flex items-center justify-center`} style={{ 
                        height: `24px`, 
                        borderRadius: `10px`,
                        padding: `3px 8px`,
                        lineHeight: `normal`,
                        fontSize: `14px`,
                        color: `#000000`
                    }}>{ params.value }</span>            
                </div>
            ): `--`}            
        </>
    )
}